import {SecureService} from "@/services/superclasses/secure-service";
import {FormResponse} from "@/interfaces/form-response";
import {Post} from "@/interfaces/post";
import {PostOverview} from "@/interfaces/post-overview";
import {DateTime} from "luxon";

const api = window.contextPath + '/rest/posts';

export class PostSecureService extends SecureService {

    public prepareNew = async (type: Array<number>): Promise<Post> => {
        return this.data(await this.get<Post>(api + "/prepare-new",
            {
                params: {
                    type
                }
            }))
    };

    public create = async (data: Post): Promise<FormResponse<Post>> => {
        return this.data(await this.post<FormResponse<Post>>(api, data))
    }

    public update = async (id: number, data: Post): Promise<FormResponse<Post>> => {
        return this.data(await this.put<FormResponse<Post>>(api + "/" + id, data))
    }

    public remove = async (id: number): Promise<any> => {
        return this.data(await this.delete(api + "/" + id));
    }

    public loadById = async (id: number): Promise<Post> => {
        return this.data(await this.get<Post>(api + "/" + id))
    };

    public copy = async (id: number): Promise<Post> => {
        return this.data(await this.get<Post>(api + "/copy/" + id))
    };

    public loadByMember = async (args: {
        type: Array<number>,
        q?: string,
        createdFrom?: DateTime,
        createdTo?: DateTime,
        newsletterFrom?: DateTime,
        newsletterTo?: DateTime,
        imported?: boolean,
        active?: boolean,
        host?: Array<number>,
        newsletterHost?: Array<number>,
        first?: number,
        max?: number
    }): Promise<PostOverview[]> => {
        return this.data(await this.get<PostOverview[]>(api + "/by-member",
            {
                params: args
            }))
    }

    public countByMember = async (args: {
        type: Array<number>,
        q?: string,
        createdFrom?: DateTime,
        createdTo?: DateTime,
        newsletterFrom?: DateTime,
        newsletterTo?: DateTime,
        imported?: boolean,
        active?: boolean,
        host?: Array<number>,
        newsletterHost?: Array<number>
    }): Promise<number> => {
        return this.data(await this.get<number>(api + "/count-by-member",
            {
                params: args
            }))
    }
}

export const postSecureService = new PostSecureService()